export default "__VITE_ASSET__DHvOilN5__"